import { conditions } from "../helpers/conditions/conditions";
import { handleVideoType } from "../helpers/helpers";
import { ConditionName } from "../interfaces/enums";
import store from "../redux/store";
import {
    ekrnAPIUrl,
    getChatAPIUrl,
    getChatBaseUrl,
    getEmojiUrl,
    getFluentdUrl,
    getGetAggregatorApiLiveUrl,
    getLoginBaseUrl,
    getMagnix,
    getRestApiCommentUrl,
    getRestApiLiveUrl,
    getRestApiUrl,
    getSetAggregatorUrl,
    uesrTracker,
    voucherAPI,
} from './baseUrl'

export const API = () => {
    const { params, details } = store.getState().videoData;
    const { bookmarkId } = store.getState().user;
    return {
        Ad: {
            getVast: `https://vfetch.yektanet.com/api/v1/load/16e31ffa-10ac-40c3-b380-fa378f8ecbb8`
        },
        live: {
            anonListConfigs: ``,
            getLiveUrl: `${getRestApiLiveUrl()}/v1/live/details/live/`,
            generalData: `${getGetAggregatorApiLiveUrl()}live/api/v1/get-aggregated/live/${params.id}/${details.id}`,
            postData: `${getSetAggregatorUrl()}live/api/v1/set-emoji-poll`,
            online_viewer: `${getSetAggregatorUrl()}live/api/v1/online-viewer/live/${details.id}/`,
            getArchiveUrl: `${getRestApiLiveUrl()}/v1/live/details/archive/`,
            getLiveMarkers: `${getRestApiLiveUrl()}/v1/live/list-event/live/`,
            multiLives: `${getRestApiLiveUrl()}/v1/live/viewers/live-archive-list/live/`,
            gifLinks: `${getEmojiUrl()}/gifs/gifConfig.json`,
            tempLink: `${getRestApiLiveUrl()}/v1/storage/temp_link/`,
            quiz: `${getSetAggregatorUrl()}live/api/v1/set-quiz`,
            quizUserRecoreds: (quizType: number, quizId: number) => `${getSetAggregatorUrl()}live/api/v1/get-user-quiz-record/${quizType}/${quizId}/`,
            liveChat: {
                getMessageList: (roomId: number) => `${getChatAPIUrl()}v1/chat/anon-list-messages/${roomId}/`,
                chat: (roomId: number) => `${getChatBaseUrl()}room/${roomId}/`,
                sendChatMessage: `${getChatAPIUrl()}v1/chat/send-message/`,
                getRoomId: (roomId: number) => `${getChatAPIUrl()}v1/chat/get-active-room/${roomId}/`
            }
        },
        vod: {
            getVodUrl: `${getRestApiLiveUrl()}/v1/live/details/vod/`,
            getVodMarkers: `${getRestApiLiveUrl()}/v1/live/list-event/vod/`,
        },
        archive: {
            getArchiveUrl: `${getRestApiLiveUrl()}/v1/live/details/archive/`,
            getArchiveMarkers: `${getRestApiLiveUrl()}/v1/live/list-event/live/`,
        },
        clip: {
            getClipUrl: `${getRestApiLiveUrl()}/v1/live/details/clip/`,
            getClipMarkers: `${getRestApiLiveUrl()}/v1/live/list-event/clip/`,
        },

        searchViewers: `${getRestApiLiveUrl()}/v2/live/viewers/search/`,
        viewersTagList: (videoType: string) => `${getRestApiLiveUrl()}/v1/live/viewers-tag-list/${videoType}/`,
        viewCount: (content_id: number) => `${getRestApiLiveUrl()}/v1/viewed/content/${content_id}`,
        like: `${getRestApiLiveUrl()}/v1/like/content/${details.content_id}`,
        dislike: `${getRestApiLiveUrl()}/v1/dislike/content/${details.content_id}`,
        unlike: `${getRestApiLiveUrl()}/v1/unlike/content/${details.content_id}`,
        undislike: `${getRestApiLiveUrl()}/v1/undislike/content/${details.content_id}`,
        recommendationList: () => {
            let urlData = `${params.type}/${conditions(ConditionName.isLiveParam) ? details.id! : +params.id!}`;
            if (conditions(ConditionName.hasUserIds)) return `${getRestApiLiveUrl()}/v1/live/recommend/${urlData}/?user_ids=${params.user_ids}`;
            return `${getRestApiLiveUrl()}/v1/live/recommend/${urlData}/`;
        },
        auth: {
            refresh: `${getRestApiUrl()}/v2/profile/auth/token-refresh/`,
            login: (v = 'v5') => `${getLoginBaseUrl()}/${v}/profile/auth/login/`,
            code: (v = 'v2') => `${getLoginBaseUrl()}/${v}/profile/auth/generate-code/`,
            validateCode: (v = 'v2') => `${getLoginBaseUrl()}/${v}/profile/auth/validate-otp/`,
            captcha: (v = 'v1') => `${getLoginBaseUrl()}/${v}/captcha/get-captcha/`,
        },
        playList: `${getRestApiLiveUrl()}/v1/live/playlist/viewers-list-videos-playlists/${params.type}/${conditions(ConditionName.isLiveParam) ? +details.id! : +params.id!}/`,
        playListVideos: (id: number) => `${getRestApiLiveUrl()}/v2/live/list-viewers-playlist-videos/${id}/`,
        comment: {
            create: `${getRestApiCommentUrl()}/v1/comment/create/`,
            commentList: (id: number) => `${getRestApiCommentUrl()}/v1/comment/list-content-comments/${id}/`,
            replyList: (id: number) => `${getRestApiCommentUrl()}/v1/comment/list-comment-replies/${id}/`,
            canAddComment: (id: number) => `${getRestApiCommentUrl()}/v1/content-get-update-delete/${id}/`,
            like: (commentId: number) => `${getRestApiLiveUrl()}/v1/like/comment/${commentId}`,
            unlike: (commentId: number) => `${getRestApiLiveUrl()}/v1/unlike/comment/${commentId}`,
        },
        serverTime: `${getRestApiUrl()}/v1/configuration/server-time/`,
        user: {
            profile: `${getMagnix()}/profiles/get_profiles`,
            profileWithXToken: `${getMagnix()}/profiles/userprofile`,
            settings: `${uesrTracker()}/v1/detail-setting/`,
            createSettings: `${uesrTracker()}/v1/create-setting/`,
            createPersonalMarker: `${uesrTracker()}/v1/create-marker/`,
            getPersonalMarker: `${uesrTracker()}/v1/list-markers/${handleVideoType()}/${conditions(ConditionName.isLiveParam) ? +details.id! : +params.id!}/`,
            updatePersonalMarker: (markerId: number) => `${uesrTracker()}/v1/get-update-delete-marker/${markerId}/`,
            deletePersonalMarker: (markerId: number) => `${uesrTracker()}/v1/get-update-delete-marker/${markerId}/`,
            getVideoMetaData: `${uesrTracker()}/v1/get-video-metadata/${handleVideoType()}/${conditions(ConditionName.isLiveParam) ? +details.id! : +params.id!}/`,
            createVideoMetaData: `${uesrTracker()}/v1/video-metadata/`,
            bookmarks: `${uesrTracker()}/v1/list-create-bookmark/`,
            deleteBookmark: (id?: number) => `${uesrTracker()}/v1/retrieve-update-delete-bookmark/${id ?? bookmarkId}/`,
        },
        trailer: {
            getList: `${getRestApiLiveUrl()}/v1/live/detail-trailer/${params.type}/${conditions(ConditionName.isLiveParam) ? +details.id! : +params.id!}/`,
        },
        videoTimelineLog: `${getFluentdUrl()}/video-timeline.log`,
        logs: `${getFluentdUrl()}/drive-endpoint.log`,
        getViewersWindow: `${getRestApiLiveUrl()}/v1/vod/get-viewer-window/${params.type}/${params.id}/`,
        web_list_config: (v = 'v1') => `${getRestApiUrl()}/${v}/configuration/list-web-configs/`,
        voucherDetail: (v = 'v1') => `${voucherAPI()}/${v}/voucher/details/${params.user_id}/${params.id}/`,
        cinemahamrah: {
            checkFreeContent: (v = 'v1') => `${voucherAPI()}/${v}/voucher/check-free-content/${params.uid}/${conditions(ConditionName.isLiveParam) ? +details.id! : +params.id!}/`,
            mciVoucherToken: (v = 'v1') => `${ekrnAPIUrl()}/${v}/voucher/mci-voucher-token/${params.uid}/`,
            userValidVouchersList: (v = 'v1') => `${voucherAPI()}/${v}/voucher/user-valid-vouchers-list/`,
            pubVoucherToken: (voucherId: string, v = 'v1') => `${voucherAPI()}/${v}/voucher/pub-voucher-token/${voucherId}`,
            voucherPackages: (v = 'v1') => `${voucherAPI()}/${v}/voucher/viewers-list-voucher-packages/`,
            paymentRequest: (vpId: number, uid: number, v = 'v1') => `${voucherAPI()}/${v}/voucher/payment-request/${vpId}/${uid}/`,
            confirmPayment: (v = 'v1') => `${voucherAPI()}/${v}/voucher/confirm-payment/`,
            getProfile: (v = 'v2') => `${getLoginBaseUrl()}/${v}/profile/auth/get-profile/`,
        }
    }
}

export const getApiUrls = () => {
    let apiUrl = "";
    let apiMarkerUrl = "";
    const { type } = store.getState().videoData.params;
    switch (type) {
        case "live":
            apiUrl = API().live.getLiveUrl;
            apiMarkerUrl = API().live.getLiveMarkers;
            break;
        case "vod":
            apiUrl = API().vod.getVodUrl;
            apiMarkerUrl = API().vod.getVodMarkers;
            break;
        case "archive":
            apiUrl = API().archive.getArchiveUrl;
            apiMarkerUrl = API().archive.getArchiveMarkers;
            break;
        case "clip":
            apiUrl = API().clip.getClipUrl;
            apiMarkerUrl = API().clip.getClipMarkers;
            break;
        default:
            break;
    }
    return {
        apiUrl,
        apiMarkerUrl
    }
}